import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { SITE, scrollToSection } from "@/lib/site";

const LINKS = [
  { label: "Services", href: "#services", testid: "nav-services" },
  { label: "Past Work", href: "#gallery", testid: "nav-gallery" },
  { label: "Service Area", href: "#service-area", testid: "nav-service-area" },
  { label: "Contact", href: "#contact", testid: "nav-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#0c0e12]/85 backdrop-blur-xl border-b border-white/10" data-testid="main-nav">
      <div className="h-20 px-6 lg:px-12 flex items-center justify-between max-w-[1400px] mx-auto">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => go(e, l.href)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-orange-500 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/admin"
            data-testid="nav-admin"
            className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 hover:text-orange-500 transition-colors duration-200"
          >
            Admin
          </a>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={SITE.phoneHref}
            data-testid="nav-cta-call"
            className="hidden sm:inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-500 text-[#0c0e12] font-mono text-xs font-bold uppercase tracking-[0.15em] px-5 py-3 transition-all duration-200 hover:-translate-y-0.5"
          >
            <Phone size={14} strokeWidth={2.5} />
            Call {SITE.phoneDisplay}
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2 border border-white/10"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-[#0c0e12]/95 backdrop-blur-xl px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={(e) => go(e, l.href)}
              className="font-mono text-sm uppercase tracking-[0.2em] text-slate-200"
            >
              {l.label}
            </a>
          ))}
          <a href="/admin" data-testid="nav-admin-mobile" className="font-mono text-sm uppercase tracking-[0.2em] text-slate-500">
            Admin
          </a>
          <a href={SITE.phoneHref} data-testid="nav-cta-call-mobile" className="font-mono text-sm font-bold uppercase tracking-[0.2em] text-orange-500">
            Call {SITE.phoneDisplay}
          </a>
        </nav>
      )}
    </header>
  );
};
